import React, { FunctionComponent } from 'react';

interface Props {
  id: string;
  value?: string;
  valueRes?: string; // Add valueRes prop
  translations?: Record<string, string>; // Add translations prop
  placeholder?: string;
  onChange: (value: string) => void;
  multiLine?: boolean;
  valid?: boolean;
  type?: string;
  icon?: string;
}

const Textbox: FunctionComponent<Props> = ({
  id,
  value,
  valueRes,
  translations,
  placeholder,
  onChange,
  multiLine,
  valid = true,
  type = 'text',
  icon,
}) => {
  if (!value && valueRes && translations && translations[valueRes]) {
    const resolvedValue = translations[valueRes];
    onChange(resolvedValue);
  }

  return (
    <div className={`form__row ${multiLine ? 'form__row--full' : ''} ${!valid ? 'invalid' : ''}`}>
      {icon && <div className="form__control--icon">%</div>}
      {multiLine && (
        <textarea
          id={id}
          placeholder={placeholder}
          className="form__control"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
        />
      )}
      {!multiLine && (
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          className="form__control"
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
        />
      )}
      <label htmlFor={id} className="form__label">
        {placeholder}
      </label>
    </div>
  );
};

export default Textbox;
